import React from 'react';
import Error from './Error.js';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, message: '' };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, message: error && error.message ? error.message : '' };
	}

	componentDidCatch(error, info) {
		console.error('Phonebook app error:', error, info);
	}

	render() {
		if (this.state.hasError) {
			return <Error message={this.state.message} />;
		}
		return this.props.children;
	}
}

export default ErrorBoundary;
